import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("samatva_admin_token", data.token);
      window.location.reload();
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const field =
    "w-full bg-transparent border-0 border-b border-samatva-ink/25 rounded-none px-0 py-3 text-base font-light text-samatva-ink placeholder:text-samatva-muted/60 focus:outline-none focus:border-samatva-plum transition-colors duration-300";

  return (
    <main
      className="min-h-screen bg-gradient-to-br from-samatva-peach via-samatva-cream to-samatva-lavender flex items-center justify-center px-6"
      data-testid="admin-login-page"
    >
      <div className="noise-overlay" />
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="w-full max-w-md bg-samatva-cream/80 backdrop-blur-md border border-samatva-line rounded-[2.5rem] p-10 md:p-12 flex flex-col gap-8"
      >
        <div className="text-center">
          <img
            src="/samatva-logo.jpeg"
            alt="Samatva logo"
            className="w-16 h-16 rounded-full object-cover mix-blend-multiply mx-auto mb-4"
          />
          <h1 className="font-serif text-3xl font-light text-samatva-ink">
            Samatva Studio
          </h1>
          <p className="text-sm font-light text-samatva-muted mt-2">
            Sign in to publish and manage articles
          </p>
        </div>
        <div>
          <label className="text-xs tracking-[0.25em] uppercase text-samatva-plum">
            Email
          </label>
          <input
            data-testid="admin-email-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@samatva.community"
            className={field}
          />
        </div>
        <div>
          <label className="text-xs tracking-[0.25em] uppercase text-samatva-plum">
            Password
          </label>
          <input
            data-testid="admin-password-input"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            className={field}
          />
        </div>
        <button
          data-testid="admin-login-submit"
          type="submit"
          disabled={loading}
          className="px-8 py-4 rounded-full bg-samatva-ink text-samatva-cream text-sm tracking-wide hover:bg-samatva-plum disabled:opacity-60 transition-colors duration-300 flex items-center justify-center gap-2"
        >
          {loading && <Loader2 size={16} className="animate-spin" />}
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </main>
  );
}
